module.exports = __webpack_public_path__ + "img/logo.a5dbff1f.png";